module.exports = __webpack_public_path__ + "static/media/icon-live.f371d479.svg";